import Utils = require("../utils");
import Mediator = require("../mediator");
import Portal = require("portal-gis");
import Base = require("./base-command");

class Handler extends Base<{ out: { command: Portal.CommandLeaf; } }> {

    static about = `
Executes a command passed as argument, prefer this.trigger("command", {command: CommandLeaf}) over Utils.execute
to allow swapping in additional "command" handlers or replacing this handler entirely.
`;

    execute(args = this.args) {
        var command = args.out.command;
        if (!command) {
            console.warn("no command provided");
            return;
        }
        Utils.log("event: ", this.configuration.id, "executing: ", command.id);
        // execute a command, cannot have in/out args otherwise execute args are invalid!
        Utils.execute(command, this.mediator, args.out);
    }
}

export = Handler; 